import { useContext } from 'react';
// eslint-disable-next-line import/extensions
import { BlockElementVariantProps } from 'node_modules/@chakra-ui/react/dist/types/styled-system/generated/recipes.gen';
import { useSlotRecipe } from '@chakra-ui/react';

import { SummaryTabContext } from '../../../../tabs';

export const useSummaryBlockElementStyle = (identifier: string) => {
  const { getBlockConfig } = useContext(SummaryTabContext);
  const { variant } = getBlockConfig(identifier);
  const recipe = useSlotRecipe({ key: 'blockElement' });
  const styles = recipe({
    variant: variant as BlockElementVariantProps['variant'],
  });

  return styles;
};
